<div class="inner-content">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="goToBack()">
        <ion-icon slot="start" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title id="modal-title" class="ion-text-center ion-no-padding ion-text-uppercase fs-pt-16">{{modalTitle}}</ion-title>
  </ion-toolbar>


  <ion-grid>
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ion-col size-sm="12" size-xl="6" size-md="8">

        <ion-item >
          <ion-label position="stacked">Data</ion-label>
          <ion-text >{{currentRicarica.data}}</ion-text>
        </ion-item>

        <ion-item >
          <ion-label position="stacked">Numero Bollettino</ion-label>
          <ion-text > {{currentRicarica.numeroBollettino}}</ion-text>
        </ion-item>

        <ion-item >
          <ion-label position="stacked" >Operatore</ion-label>
          <ion-text >{{currentRicarica.operatore}}</ion-text>
        </ion-item>

        <ion-item >
          <ion-label position="stacked">Valore</ion-label>
          <ion-text >{{currentRicarica.valore}}</ion-text>
        </ion-item>

        <ion-item >
          <ion-label position="stacked">Note</ion-label>
          <ion-text >{{currentRicarica.note}}</ion-text>
        </ion-item>

        <ion-accordion-group>
          <ion-accordion value="first">
            <ion-item slot="header">
              <ion-label><b>Aggiornamenti</b></ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              @for (aggiornmento of currentRicarica.aggiornamenti; track aggiornmento; let i = $index) {
                <ion-item >
                  <ion-label position="stacked">Data Operazione</ion-label>
                  <ion-text >{{aggiornmento.dataOperazione}}</ion-text>
                </ion-item>
                <ion-item >
                  <ion-label position="stacked">Operatore</ion-label>
                  <ion-text >{{aggiornmento.operatore}}</ion-text>
                </ion-item>
                <ion-item >
                  <ion-label position="stacked">Commento operatore</ion-label>
                  <ion-text >{{aggiornmento.commentoOperatore}}</ion-text>
                </ion-item>
                <ion-item >
                  <ion-label position="stacked">Operazione</ion-label>
                  <ion-text >{{joinOperazioni(aggiornmento.operazioni)}}</ion-text>
                </ion-item>
                @if (!!currentRicarica.aggiornamenti && (i < (currentRicarica.aggiornamenti.length - 1))) {
                  <hr class="new1 ion-margin-top">
                }
              }

            </div>
          </ion-accordion>
        </ion-accordion-group>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
